<template>
  <div class="comment-box">
    <div class="comment-list">
      <div v-if="data.length == 0" style="padding: 15px 0px">
        <p class="text-center">Henüz hiç yorum yapılmamış</p>
      </div>
      <div class="comment-block" v-for="item in data" :key="item.id">
        <div class="comment-image">
          <img
            @click="getProfile(item.user.id)"
            style="width: 42px; height: 42px; border-radius: 50%"
            :src="item.user.avatar_url"
            class="w-100 rounded-circle"
          />
        </div>
        <div class="comment-area">
          <div class="comment-top clearfix">
            <a
              class="float-left fc-1 fs-2 font-weight-bold"
              @click="getProfile(item.user.id)"
              href="javascript:;"
              >{{ item.user.name }}</a
            >
            <p class="text-secondary text-center float-right fc-3 fs-11">
              {{ $fromNow(item.date.date) }}
            </p>
          </div>
          <div class="comment-body">
            <p>{{ item.comment }}</p>
          </div>
          <div
            class="comment-bottom text-right"
            style="display: flex; align-items: center; flex-direction: row; justify-content: space-between"
          >
            <div
              style="display: flex; flex-direction: row; align-items: center; "
            >
              <a
                :class="item.is_liked ? 'liked' : ''"
                href="javascript:;"
                @click="toggleLike(item.id)"
                style="width: 50px; height: 40px; display: inline-block; display: flex; align-items: center; justify-content: center; font-size: 20px; color: #333"
              >
                <i class="ion-md-thumbs-up"></i>
              </a>
              <a
                href="javascript:;"
                style="color: #333; height: 40px; font-size: 13px; display: flex; align-items: center; justify-content: center"
              >
                <span>{{ item.like_count }} beğeni</span>
              </a>
            </div>
            <a
              href="javascript:;"
              @click="
                comment_id = item.id;
                showActionSheet();
              "
              class="fc-3 fs-11 font-weight-bold"
              >Şikayet Et</a
            >
          </div>
        </div>
      </div>
    </div>
    <slot name="comment" v-if="$store.getters.isLogged"></slot>
    <div
      v-if="$store.getters.isLogged == false"
      style="display: flex; align-items: center; justify-content: center; flex-direction: column"
    >
      <p
        class="text-center"
        style="color: gray; margin-top: 15px; margin-bottom: 15px"
      >
        Yorum yapabilmek için giriş yapmanız gerekmektedir.
      </p>
      <div>
        <router-link :to="{ name: 'Login' }" class="fc-2" style="padding: 10px"
          >Giriş Yap</router-link
        >
        <router-link
          :to="{ name: 'Register' }"
          class="fc-2"
          style="padding: 10px"
          >Kayıt Ol</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Comment",
  props: ["data"],
  data() {
    return {
      comment_id: null,
      lock: false
    };
  },
  methods: {
    showActionSheet() {
      if (!this.$store.getters.isLogged) {
        this.$router.push({ name: "Login" });
        return;
      }
      this.$iosActionSheet([
        {
          label: true,
          text: "Şikayet Et"
        },
        {
          text: "Uygunsuz içerik",
          handle: this.complain(0)
        },
        {
          text: "Reklam içeriyor",
          handle: this.complain(1)
        },
        {
          text: "Vazgeç"
        }
      ]);
    },
    complain(index, id) {
      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("comment_id", this.comment_id);
      data.append(
        "complain_reason",
        index == 1 ? "Uygunsuz içerik" : "Reklam içeriyor"
      );

      axios.post("yorum/sikayet", data).then(res => {
        this.$emit("commentDeleted");
        this.$notify({
          title: "Başarılı",
          message: res.data.message,
          type: "success"
        });
      });
    },
    getProfile(id) {
      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("user_id", id);
      axios.post("sosyal/profil", data).then(res => {
        if (res.data.status == 401) {
          this.$message.error(res.data.data);
          return;
        }
        this.$router.push({
          name: "UserProfile",
          params: {
            data: res.data.data,
            id: res.data.data.id,
            slug: res.data.data.slug
          }
        });
      });
    },
    toggleLike(id) {
      if (this.lock == true) {
        return;
      }
      this.lock = true;
      var data = new FormData();
      data.append("comment_id", id);
      data.append("user_token", this.$store.state.user.token);
      axios
        .post("yorum/begen", data)
        .then(res => {
          setTimeout(() => {
            this.lock = false;
          }, 1000);
          var index = this.data.findIndex(k => k.id == id);
          this.data[index].is_liked =
            res.data.like_count > this.data[index].like_count ? true : false;
          this.data[index].like_count = res.data.like_count;
        })
        .catch(err => {
          setTimeout(() => {
            this.lock = false;
          }, 1000);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Comment.vue